import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataVv from './phonics/phonics_data_vv';

function PhonicsVv() {
  return <PhonicsAtoZ letterData={letterDataVv} />;
}

export default PhonicsVv;
